import { Inject, Injectable, Optional } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root',
})
export class GtmService extends GoogleTagManagerService {
  constructor(
    @Optional() @Inject('googleTagManagerId') public googleTagManagerId: string,
    @Optional()
    @Inject('googleTagManagerAuth')
    public googleTagManagerAuth: string,
    @Optional()
    @Inject('googleTagManagerPreview')
    public googleTagManagerPreview: string,
    @Optional()
    @Inject('googleTagManagerResoucePath')
    public googleTagManagerResoucePath: string
  ) {
    super(
      { id: null },
      'XXXXXX',
      googleTagManagerAuth,
      googleTagManagerPreview,
      googleTagManagerResoucePath
    );
  }

  setGtmId(gtmId: string) {
    this.config.id = gtmId;
    this.googleTagManagerId = gtmId;
  }
}
